export default __webpack_public_path__ + "e63a08e236b460eb9d478e8fc83ad359.svg";